import { useContext } from 'react';

import { PageContext } from 'application/adapters/context/PageContext';

const toLink = (page: Umbraco.HomePage): Umbraco.Link | null => {
	const navSetting = page.properties.pageSettings?.find((s) => s.documentType === 'navigation');
	if (navSetting?.content.properties.umbracoNaviHide) return null;

	const { navigationTitle } = navSetting?.content?.properties ?? {};
	return {
		name: navigationTitle ?? page.name,
		url: page.url,
		target: '_self',
	};
};

export const useDynamicBottomMenuLinks = (sameLevelNavigation: boolean) => {
	const pageContext = useContext(PageContext);
	const page = pageContext.pageType?.page;
	const parent = pageContext.pageType?.parent;

	const items = sameLevelNavigation ? parent?.children?.filter((sibling) => sibling.id !== page?.id) : page?.children;

	const links: Umbraco.Link[] = items?.map(toLink).filter((link): link is Umbraco.Link => Boolean(link)) ?? [];

	const backUrl = parent?.url;

	return { links, backUrl };
};
